import { AxiosInstance } from "axios";
import { BootstrapResponse, BullenMatchupResponse, BullenStandingResponse, FixtureResponse, LiveWeekResponse, TeamPicksResponse } from "../models/api";

/**
 * bootstrap-static is 1.7MB and changes rarely, so it is fetched once per api instance
 * and shared by every screen. A failed fetch is forgotten so a retry can succeed.
 */
const bootstrapCache = new WeakMap<AxiosInstance, Promise<BootstrapResponse>>();

export const fetchBootstrap = (api: AxiosInstance): Promise<BootstrapResponse> => {
	const cached = bootstrapCache.get(api);
	if (cached) {
		return cached;
	}

	const request = api.get<BootstrapResponse>("/bootstrap-static/").then((r) => r.data);
	request.catch(() => bootstrapCache.delete(api));
	bootstrapCache.set(api, request);
	return request;
};

export const fetchLiveWeek = (api: AxiosInstance, weekId: number) => api.get<LiveWeekResponse>(`/event/${weekId}/live/`).then((r) => r.data);

export const fetchFixtures = (api: AxiosInstance, weekId: number) => api.get<FixtureResponse[]>(`/fixtures/?event=${weekId}`).then((r) => r.data);

export const fetchLeagueMatches = (api: AxiosInstance, leagueId: number, weekId: number) =>
	api.get<BullenMatchupResponse>(`/leagues-h2h-matches/league/${leagueId}/?page=1&event=${weekId}`).then((r) => r.data);

export const fetchEntryPicks = (api: AxiosInstance, entryId: number, weekId: number) => api.get<TeamPicksResponse>(`/entry/${entryId}/event/${weekId}/picks/`).then((r) => r.data);

export const fetchStandings = (api: AxiosInstance, leagueId: number) => api.get<BullenStandingResponse>(`/leagues-h2h/${leagueId}/standings/`).then((r) => r.data);
